import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChecklistCategory } from '../classes/checklistCategory';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ChecklistCategoryService {
    API_CHECKLIST_CATEGORY_URL = config.serverAddress + ':' + config.serverPort + '/checklist-category/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CHECKLIST_CATEGORY_URL + 'all');
    }
    getByID(id: string | null | undefined) {
        return this.http.get(this.API_CHECKLIST_CATEGORY_URL + id);
    }
    getByChecklistID(checklistID: string | null) {
        return this.http.get(this.API_CHECKLIST_CATEGORY_URL + 'checklist/' + checklistID);
    }
    create(checklistCategory: ChecklistCategory) {
        return this.http.post(this.API_CHECKLIST_CATEGORY_URL + 'create', checklistCategory);
    }
    update(checklistCategory: ChecklistCategory) {
        return this.http.put(this.API_CHECKLIST_CATEGORY_URL + 'update', checklistCategory);
    }
    delete(id: number | null) {
        return this.http.delete(this.API_CHECKLIST_CATEGORY_URL + 'delete/' + id);
    }
}